import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import PaymentIcon from '@mui/icons-material/Payment';
import CustomCard from '../../../Shared/Components/CustomCard/CustomCard';
import { useGetReservationPaymentsQuery } from '../../Service/reservationPaymentsApi';
import PaymentSummary from './PaymentSummary';
import PaymentHistoryTable from './PaymentHistoryTable';

interface ReservationPaymentHistorySectionProps {
  reservationId: number;
  totalPrice: number;
}

const ReservationPaymentHistorySection: React.FC<ReservationPaymentHistorySectionProps> = ({
  reservationId,
  totalPrice,
}) => {
  const { data: payments = [], isLoading, error } = useGetReservationPaymentsQuery(reservationId);

  // Calculate totals
  const totalPaid = payments.reduce((sum, p) => sum + p.amount, 0);
  const paymentsCount = payments.filter((p) => p.amount >= 0).length;
  const refundsCount = payments.filter((p) => p.amount < 0).length;

  if (error) {
    return (
      <CustomCard icon={<PaymentIcon fontSize="large" color="error" />} title="Historia płatności">
        <Alert severity="error">
          Nie udało się pobrać historii płatności. Spróbuj ponownie później.
        </Alert>
      </CustomCard>
    );
  }

  return (
    <>
      <CustomCard
        icon={<PaymentIcon fontSize="large" color="primary" />}
        title="Historia płatności"
      >
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {/* Payment Summary */}
            <PaymentSummary
              totalPrice={totalPrice}
              totalPaid={totalPaid}
              paymentsCount={paymentsCount}
              refundsCount={refundsCount}
            />

            {/* Payment History Table */}
            <Box sx={{ mt: 3 }}>
              <PaymentHistoryTable payments={payments} isLoading={isLoading} />
            </Box>
          </>
        )}
      </CustomCard>
    </>
  );
};

export default ReservationPaymentHistorySection;
